export default class ConfirmDeleteModalView extends Backbone.View
  events:
    "keyup .js-delete-confirmation-input"   : "keyupOnInput"
    "click .js-type-delete-confirmed"       : "typeDeleteConfirmed"
    "modal:afterClose"                      : "onCloseDeleteModal"

  initialize: ->
    @deleteConfirmationForm = @$el.find("form.js-delete-confirmation")

  keyupOnInput: ->
    deleteButton = @$el.find(".js-type-delete-confirmed")
    if @deleteConfirmationForm.parsley().isValid()
      contently.ui.enable_button(deleteButton)
    else
      contently.ui.disable_button(deleteButton)

  typeDeleteConfirmed: ->
    @deleteConfirmationForm.trigger("confirm-delete-modal:confirmed")
    contently.ui.closeModal("confirm-delete-modal")

  onCloseDeleteModal: ->
    # always empty field + reset parsley since we allow escaping
    @$el.find(".js-delete-confirmation-input").val("")
    @deleteConfirmationForm.parsley().reset()



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/confirm_delete_modal_view.js.coffee